import {WILL_LIST_DATA} from "../Types/WillItem/willitem";

const initialState = {
  data: null
}

export default function willListReducer (state = initialState, action) {
  switch (action.type) {
    case WILL_LIST_DATA:
      return {
        ...state,
        data: action.payload
      }
    default:
      return state;
  }
}
